<template>
  <page-section :description="$t('RetentionHistory_Subtitle')">
    <rest-list :payload="fetchEndpoint" :per-page="50" ref="restList">
      <rest-list-column-enum
        prop="identifier"
        :title="$t('RetentionHistory_Field_Type')"
        :enum="RetentionHistoryAction"
        :sortable="false"
        :filterable="true"
      />

      <rest-list-column-enum
        prop="run_type"
        :title="$t('RetentionHistory_Field_RunType')"
        :enum="RetentionHistoryRunType"
        :sortable="false"
        :filterable="true"
      />

      <rest-list-column-enum
        prop="status"
        :title="$t('RetentionHistory_Field_Status')"
        :enum="statusLabel"
        :sortable="false"
        :filterable="true"
      />

      <rest-list-column-date
        prop="start_time"
        :title="$t('RetentionHistory_Field_Start')"
        :sortable="true"
        :filterable="true"
        :width="200"
      />

      <rest-list-column-date
        prop="finish_time"
        :title="$t('RetentionHistory_Field_Finish')"
        :sortable="true"
        :filterable="true"
        :width="200"
      />

      <rest-list-column
        prop="total_deleted"
        :title="$t('RetentionHistory_Field_RecordsAffected')"
        :filterable="false"
        :sortable="false"
        :filter-input="false"
      />

      <rest-list-column
        prop="high_deletion_warning"
        :title="$t('RetentionHistory_Field_Warnings')"
        :sortable="false"
        :filterable="false"
      >
        <template v-slot="scope">
          <el-tooltip
            v-if="scope.row.high_deletion_warning"
            :content="$t('RetentionHistory_HighImpactAlert')"
            placement="bottom"
          >
            <i class="el-icon-warning"></i>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </rest-list-column>

      <rest-list-column
        prop="task_id"
        :title="$t('RetentionHistory_Field_TaskLink')"
        :sortable="false"
        :filterable="false"
      >
        <template v-slot="scope">
          <router-link
            v-if="
              Number.isInteger(scope.row.task_id) && scope.row.task_id !== 0
            "
            :to="rowViewTask(scope.row)"
            target="_blank"
          >
            {{ $t('RetentionHistory_Task_Link') }}
          </router-link>
          <div v-else>
            -
          </div>
        </template>
      </rest-list-column>
    </rest-list>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import {
  RetentionHistoryAction,
  RetentionHistoryRunType
} from '@/modules/settings/enum/RetentionHistoryType'
import { taskStatusLabel as statusLabel } from '@/modules/tasks/enum/TaskRecordEnums'

export default {
  name: 'DataRetentionHistoryTab',

  components: {
    PageSection,
    RestListColumnDate,
    RestListColumn,
    RestListColumnEnum,
    RestList
  },

  data() {
    return {
      RetentionHistoryAction,
      RetentionHistoryRunType,
      statusLabel
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'retention-policy/history'
      })
    }
  },

  methods: {
    rowViewTask(row) {
      return projectRoute({
        name: 'TaskHistoryView',
        query: { id: row.task_id }
      })
    }
  }
}
</script>

<style scoped>
.summary {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/components/DataRetentionHistoryTab.vue